import { styled } from '@nykaa/ui-components';

export const Wrapper = styled.div<{ isCollapsedView: boolean }>`
  ${({ isCollapsedView, theme }) =>
    !isCollapsedView &&
    `border-top: 1px solid ${theme.colors.textDecorative};
    border-bottom: 1px solid ${theme.colors.textDecorative};
    `};
`;
